import { Call } from '@twilio/voice-sdk';

const InProgress: readonly string[] = [
	Call.State.Connecting,
	Call.State.Open,
	Call.State.Reconnecting,
	Call.State.Ringing,
];

/** `Pending` is an inbound leg the rep has not answered yet — see the two predicates below. */
const Committed: readonly string[] = [...InProgress, Call.State.Pending];

/**
 * Whether a newer inbound leg would be taking over from a call in progress. Excludes an
 * unanswered leg, which a newer one is allowed to supersede.
 */
export function isLiveCall(call: Call | undefined): boolean {
	return !!call && InProgress.includes(call.status());
}

/**
 * Whether the rep is committed to this leg, so another tab must not take the Device
 * without asking. Includes an unanswered inbound leg: it is still ringing, and taking the
 * Device would drop it — which is the call the blinking favicon is pointing the rep at.
 */
export function isCommittedToCall(call: Call | undefined): boolean {
	return !!call && Committed.includes(call.status());
}
